document.querySelectorAll('.dfa-plot').forEach(function(plot){
    plot.addEventListener('click', function(){
      var target = document.querySelector(plot.getAttribute('data-target'));
      if(!target) return;
      target.scrollIntoView({behavior:'smooth', block:'center'});
      target.classList.remove('dfa-flash');
      void target.offsetWidth;
      target.classList.add('dfa-flash');
    });
  });

  document.querySelectorAll('.dfa-quiz-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var target = document.querySelector(btn.getAttribute('data-target'));
      if(!target) return;
      target.scrollIntoView({behavior:'smooth', block:'center'});
      target.classList.remove('dfa-flash');
      void target.offsetWidth;
      target.classList.add('dfa-flash');
    });
  });

  var trepackScents = {
    lavendel: { name:'Lavendel', color:'var(--grape)', bg:'var(--grape-soft)', desc:'Mjuk, blommig doft. Perfekt när du hittat din favorit och bara vill fylla på.', icon:'<path d="M6 16a4 4 0 0 1 0-8 5 5 0 0 1 9.6-1.5A4.5 4.5 0 0 1 18 16H6Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' },
    citron: { name:'Citron', color:'#B8860B', bg:'var(--yellow-soft)', desc:'Skarp, solig citrusdoft. Perfekt när du hittat din favorit och bara vill fylla på.', icon:'<path d="M12 3c2 3 4 6.2 4 9a4 4 0 1 1-8 0c0-2.8 2-6 4-9Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' },
    fresh: { name:'Fresh', color:'var(--teal)', bg:'var(--teal-soft)', desc:'Ren, neutral doft. Perfekt när du hittat din favorit och bara vill fylla på.', icon:'<path d="M12 3c2.5 3 4 6.2 4 9a4 4 0 1 1-8 0c0-2.8 1.5-6 4-9Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' }
  };
  var trepackVariants = {
    '3': { lavendel:'53837683097947', citron:'53837691715931', fresh:'53837692895579' },
    '6': { lavendel:'53837693682011', citron:'53837693845851', fresh:'53837693976923' }
  };
  var trepackScent = 'lavendel';
  var trepackSize = '3';
  function trepackSyncVariant(){
    var btn = document.getElementById('trepackAddBtn');
    if(btn) btn.setAttribute('data-variant-id', trepackVariants[trepackSize][trepackScent]);
  }
  document.querySelectorAll('.dfa-scent-swatch').forEach(function(sw){
    sw.addEventListener('click', function(){
      document.querySelectorAll('.dfa-scent-swatch').forEach(function(s){ s.classList.remove('dfa-active'); });
      sw.classList.add('dfa-active');
      trepackScent = sw.getAttribute('data-scent');
      var scent = trepackScents[trepackScent];
      var icon = document.getElementById('trepackIcon');
      icon.style.background = scent.bg;
      icon.style.color = scent.color;
      icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none">' + scent.icon + '</svg>';
      document.getElementById('trepackScentName').textContent = scent.name;
      document.getElementById('trepackDesc').textContent = scent.desc;
      trepackSyncVariant();
    });
  });

  var singleVariants = { lavendel: '53837674250587', citron: '53837675823451', fresh: '53837676937563' };
  var mixMode = false;
  var mixQty = { lavendel: 2, citron: 2, fresh: 2 };
  var mixToggleEl = document.getElementById('trepackMixToggle');
  var mixPickerEl = document.getElementById('trepackMixPicker');
  var mixSumEl = document.getElementById('mixSum');
  var scentPickerEl = document.querySelector('#p-trepack .dfa-scent-picker');

  function updateMixUI(){
    document.getElementById('mixQtyLavendel').textContent = mixQty.lavendel;
    document.getElementById('mixQtyCitron').textContent = mixQty.citron;
    document.getElementById('mixQtyFresh').textContent = mixQty.fresh;
    var sum = mixQty.lavendel + mixQty.citron + mixQty.fresh;
    mixSumEl.textContent = sum + ' av 6 valda';
    mixSumEl.classList.toggle('dfa-mix-sum--ok', sum === 6);
    mixSumEl.classList.toggle('dfa-mix-sum--error', sum !== 6);
  }

  document.querySelectorAll('#trepackMixPicker .dfa-mix-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var scent = btn.getAttribute('data-scent');
      var dir = parseInt(btn.getAttribute('data-dir'), 10);
      mixQty[scent] = Math.max(0, Math.min(6, mixQty[scent] + dir));
      updateMixUI();
    });
  });

  function exitMixMode(){
    mixMode = false;
    if(scentPickerEl) scentPickerEl.hidden = false;
    if(mixPickerEl) mixPickerEl.hidden = true;
    trepackSyncVariant();
    var activeSwatch = document.querySelector('#p-trepack .dfa-scent-swatch.dfa-active');
    if(activeSwatch){
      var s = trepackScents[activeSwatch.getAttribute('data-scent')];
      document.getElementById('trepackTierName').textContent = trepackSize + '-pack';
      document.getElementById('trepackScentName').textContent = s.name;
      document.getElementById('trepackDesc').textContent = s.desc;
    }
  }

  if(mixToggleEl){
    mixToggleEl.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        mixToggleEl.querySelectorAll('button').forEach(function(b){ b.classList.remove('dfa-active'); });
        btn.classList.add('dfa-active');
        if(btn.getAttribute('data-mix') === 'blend'){
          mixMode = true;
          if(scentPickerEl) scentPickerEl.hidden = true;
          if(mixPickerEl) mixPickerEl.hidden = false;
          document.getElementById('trepackTierName').textContent = '6-pack';
          document.getElementById('trepackScentName').textContent = 'Blandat';
          document.getElementById('trepackDesc').textContent = 'Sex rullar, valfri blandning av alla tre dofter.';
          updateMixUI();
        } else {
          exitMixMode();
        }
      });
    });
  }

  (function(){
    var overlay = document.getElementById('dfaPopupOverlay');
    if(!overlay) return;
    var closeBtn = document.getElementById('dfaPopupClose');
    var skipBtn = document.getElementById('dfaPopupSkip');
    var form = document.getElementById('dfaPopupSubmitForm');
    var formView = document.getElementById('dfaPopupForm');
    var successView = document.getElementById('dfaPopupSuccess');
    var copyBtn = document.getElementById('dfaPopupCopy');
    var codeEl = document.getElementById('dfaPopupCode');
    var errorEl = document.getElementById('dfaPopupError');
    var STORAGE_KEY = 'dfaWelcomePopupSeen';

    function hide(){
      overlay.classList.remove('dfa-show');
      try{ localStorage.setItem(STORAGE_KEY, '1'); }catch(e){}
    }

    try{
      if(!localStorage.getItem(STORAGE_KEY)){
        setTimeout(function(){ overlay.classList.add('dfa-show'); }, 1800);
      }
    }catch(e){}

    closeBtn.addEventListener('click', hide);
    skipBtn.addEventListener('click', hide);
    overlay.addEventListener('click', function(e){ if(e.target === overlay) hide(); });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      errorEl.style.display = 'none';
      var email = form.email.value;
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Skickar…';

      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '✓');
      body.set('contact[tags]', 'newsletter');
      body.set('contact[email]', email);

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      })
      .then(function(res){
        if(!res.ok) throw new Error('request failed');
        formView.hidden = true;
        successView.hidden = false;
        try{ localStorage.setItem(STORAGE_KEY, '1'); }catch(e){}
      })
      .catch(function(){
        submitBtn.disabled = false;
        submitBtn.textContent = 'Lås upp 15%';
        errorEl.style.display = 'block';
      });
    });

    copyBtn.addEventListener('click', function(){
      var text = codeEl.textContent;
      if(navigator.clipboard){
        navigator.clipboard.writeText(text).then(function(){
          copyBtn.textContent = 'Kopierad!';
          setTimeout(function(){ copyBtn.textContent = 'Kopiera kod'; }, 1500);
        });
      }
    });
  })();

  var countEl = document.getElementById('cartCount');
  var shipEl = document.getElementById('shipProgress');
  var FREE_SHIP_THRESHOLD = 14900;

  function updateCartUI(cart){
    if(countEl) countEl.textContent = cart.item_count;
    if(shipEl){
      var remaining = FREE_SHIP_THRESHOLD - cart.total_price;
      shipEl.textContent = remaining > 0 ? (Math.ceil(remaining/100)) + ' kr kvar till fri frakt' : 'Fri frakt uppnådd';
    }
  }

  fetch('/cart.js').then(function(r){ return r.json(); }).then(updateCartUI).catch(function(){});

  document.querySelectorAll('.dfa-add-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var isMixAdd = (btn.id === 'trepackAddBtn' && mixMode);
      var mixSum = mixQty.lavendel + mixQty.citron + mixQty.fresh;
      if(isMixAdd && mixSum !== 6){
        updateMixUI();
        return;
      }
      var variantId = btn.getAttribute('data-variant-id');
      if(!isMixAdd && !variantId) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Lägger till…';
      var body = isMixAdd
        ? { items: ['lavendel','citron','fresh'].filter(function(s){ return mixQty[s] > 0; }).map(function(s){ return { id: singleVariants[s], quantity: mixQty[s] }; }) }
        : { items: [{ id: variantId, quantity: 1 }] };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function(res){
        if(!res.ok){ return res.json().then(function(err){ throw new Error(err.description || 'Kunde inte lägga till'); }); }
        return fetch('/cart.js').then(function(r){ return r.json(); });
      })
      .then(function(cart){
        updateCartUI(cart);
        btn.textContent = 'Tillagd ✓';
        btn.classList.add('dfa-added');
      })
      .catch(function(err){
        btn.textContent = 'Kunde inte lägga till';
      })
      .finally(function(){
        setTimeout(function(){
          btn.textContent = original;
          btn.classList.remove('dfa-added');
          btn.disabled = false;
        }, 1400);
      });
    });
  });

  document.querySelectorAll('.dfa-product-card').forEach(function(card){
    var priceEl = card.querySelector('.dfa-price');
    if(!priceEl) return;

    function render(){
      priceEl.textContent = priceEl.getAttribute('data-base') + ' kr';
    }

    var sizeBtns = card.querySelectorAll('.dfa-size-btn');
    if(sizeBtns.length){
      var badgeEl = card.querySelector('.dfa-badge');
      var tierNameEl = card.querySelector('#trepackTierName');
      sizeBtns.forEach(function(btn){
        btn.addEventListener('click', function(){
          sizeBtns.forEach(function(b){ b.classList.remove('dfa-active'); });
          btn.classList.add('dfa-active');
          priceEl.setAttribute('data-base', btn.getAttribute('data-price'));
          if(badgeEl) badgeEl.textContent = btn.getAttribute('data-badge');
          if(tierNameEl) tierNameEl.textContent = btn.getAttribute('data-size') + '-pack';
          trepackSize = btn.getAttribute('data-size');
          if(mixToggleEl) mixToggleEl.hidden = (trepackSize !== '6');
          if(trepackSize !== '6' && mixMode){
            mixToggleEl.querySelector('[data-mix="same"]').classList.add('dfa-active');
            mixToggleEl.querySelector('[data-mix="blend"]').classList.remove('dfa-active');
            exitMixMode();
          } else {
            trepackSyncVariant();
          }
          render();
        });
      });
    }
  });
